import { useMemo } from 'react';
import { prop } from 'ramda';
import { useUserSelector } from 'js/store/hooks';

export const useAmounts = ({ bonusTemplate }) => {
    const { bonusConditions = [] } = bonusTemplate || {};
    const currencyCode = useUserSelector(prop('currencyCode'));

    return useMemo(() => {
        const { amounts = [] } = bonusConditions[0] || {};

        return amounts
            .filter(amount => amount.currencyCode === currencyCode)
            .map(amount => Object.entries(amount)
                .reduce((acc, [key, value]) => ({
                    ...acc,
                    [key]: Number(value) ? Number(value) : value
                }), {})
            );
    }, [currencyCode, bonusConditions]);
};
